import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

import IPosition from 'types/Position';
import { executeFunctionsCurried } from 'utils/functionUtils';

import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useFeatureFlags } from 'utils/features';
import { getRequireDescriptionTitleValue } from 'utils/positionUtils';
import { RequireDescriptionSettingsForm } from '../forms/RequireDescriptionSettingsForm';

export interface IRequireDescriptionSettingsDetailProps {
  className?: ClassName;
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
}

const RequireDescriptionSettingsDetail = (props: IRequireDescriptionSettingsDetailProps) => {
  const { className, position, onUpdate, editable } = props;

  const isRequireDescriptionEnabled = useFeatureFlags('REQUIRE_TIME_ENTRY_DESCRIPTION');
  const formOpenable = useOpenable();

  function getPositionValue() {
    const requireTimeEntryDescription = position.requireTimeEntryDescription;
    return getRequireDescriptionTitleValue(!!requireTimeEntryDescription);
  }

  const classes = classNames('require-description-settings-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Require Description')}
        onClick={formOpenable.open}
        value={getPositionValue()}
        hint={t(
          'When clocking their own time, require employees to have a description on their time entry before switching or clocking out.'
        )}
        className={classes}
        disabled={!editable || !isRequireDescriptionEnabled}
      />
      <Dialog position={'center'} isOpen={formOpenable.isOpen} onClose={formOpenable.close}>
        <RequireDescriptionSettingsForm
          className="mt-4 p-8"
          position={position}
          onSubmit={executeFunctionsCurried(onUpdate, formOpenable.close)}
        />
      </Dialog>
    </>
  );
};

export default RequireDescriptionSettingsDetail;
